import { collageWall } from "@/mocks/kanliao";

export default function CollageZone() {
  return (
    <section id="wall" className="border-t border-background-200 bg-foreground-950">
      <div className="mx-auto max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-wrap items-end justify-between gap-3">
          <div>
            <p className="flex items-center gap-2 text-xs font-semibold tracking-widest text-accent-400">
              <i className="ri-layout-masonry-fill" />
              MEGA · 高能合集
            </p>
            <h2 className="mt-2 font-heading text-2xl font-black text-background-50 md:text-3xl">
              高能话题合集墙，一次刷个够
            </h2>
            <p className="mt-2 max-w-xl text-sm text-background-100/70">
              把散落的高能瞬间按话题收编成册，图文同框，越往下越上头。
            </p>
          </div>
          <span className="inline-flex items-center gap-1.5 rounded-full border border-background-100/20 bg-background-100/10 px-3 py-1.5 text-xs text-background-100/80">
            共 6 大合集 · 持续扩编
          </span>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {collageWall.map((c) => (
            <a
              key={c.label}
              href="#scoop"
              className="group relative block h-52 w-full overflow-hidden rounded-lg"
            >
              <img
                src={c.image}
                alt={c.title}
                title={c.title}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/20 to-transparent" />
              <span className="absolute left-3 top-3 rounded-md bg-accent-500 px-2 py-0.5 text-[11px] font-black text-foreground-950">
                {c.theme}
              </span>
              <div className="absolute inset-x-0 bottom-0 p-4">
                <p className="flex items-center gap-1.5 text-[11px] font-semibold text-accent-300">
                  {c.label}
                </p>
                <h3 className="mt-1.5 line-clamp-2 font-heading text-lg font-bold leading-snug text-background-50">
                  {c.title}
                </h3>
                <p className="mt-2 flex items-center gap-2 text-[11px] text-background-100/80">
                  <span className="flex items-center gap-1">
                    <i className="ri-chat-3-fill" />
                    {c.chat} 吃瓜
                  </span>
                  <span className="flex items-center gap-1 opacity-0 transition-opacity group-hover:opacity-100">
                    进入合集
                    <i className="ri-arrow-right-line" />
                  </span>
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}